//import { AllModules, ColDef, GridOptions } from '@ag-grid-enterprise/all-modules';
import { ColDef, GridOptions, GridApi } from "ag-grid-community";

import { DatePipe } from '@angular/common';
import { HttpResponse } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild, Input} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { filter, map, mergeMap, tap } from 'rxjs/operators';
import { ContactStub, Contact } from "../../../../admin/models/contact.model";
import { Group } from "../../../../admin/models/group.model";
import { GroupSearchSpec, GroupService } from "../../../../admin/services/group.service";
import { ActionCellRendererComponent } from "../../../../common/components/ag-grid/action-cell-renderer.component";
import { ModalInfoComponent } from '../../../../common/components/ag-grid/modal-info.component';
import { RouterLinkRendererComponent } from '../../../../common/components/ag-grid/router-link-renderer.component';
import { dateComparator } from '../../../../common/components/data-table/comparators/data-table.comparators';
import { FlowIndex } from '../../../../common/models/flow.dto';
import { OnBaseDocumentTypeSearchSpec, OnBaseKeyword, OnBaseKeywordQuery, OnBaseQueryModel, parseFileNameFromHeaders, QueryResult } from "../../../../common/models/onBaseIntegrationAndMapping.model";
import { OrganizationStub } from '../../../../common/models/organization.model';
import { PendingWorkOrderAssignment } from '../../../../common/models/work-order.model';
import { DateService } from '../../../../common/services/date.service';
import { DocumentManagementService } from "../../../../common/services/document-management.service";
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { LoaderService } from "../../../../common/services/loader.service";
import { WorkOrderService } from '../../../../common/services/work-order.service';
import { Dialog, DialogButton } from "../../../../core/models/dialog.model";
import { SortAttribute } from "../../../../core/models/sort.model";
import { DynamicDialogService } from "../../../../core/services/dynamic-dialog.service";
import { PendingFlow } from '../../../../flow/models/flow.model';
import { FlowInstanceService } from '../../../../flow/services/flow-instance.service';
import { LunaClaimValues, UserIdentity } from '../../../../models/user-identity.model';
import { AuthService } from '../../../../services/auth.service';
import { DataCorrectionService } from '../../../../services/dataCorrection.service';
import { ViewBase } from "../view-base";


@Component({
    selector: 'data-correction-requests-internal-widget',
    templateUrl: './data-correction-requests-internal-widget.component.html',
    styleUrls: ['./data-correction-requests-internal-widget.component.scss'],
    standalone: false
})
export class DataCorrectionRequestsInternalWidgetComponent extends ViewBase implements OnInit {
    @Input() widgetTitle: string;
 
    allUsers: ContactStub[] = [];
    groups: Group[] = [];
    filteredUsers: ContactStub[] = [];

    @ViewChild("downloadLink") documentLink: ElementRef;

	adHocReviewGridOptions: GridOptions;
	adHocReviewGridApi?: GridApi;
	pendingReviewGridOptions: GridOptions;
	pendingReviewGridApi?: GridApi;
	approvedGridOptions: GridOptions;
	approvedGridApi?: GridApi;
	returnedGridOptions: GridOptions;
	returnedGridApi?: GridApi;
	deniedGridOptions: GridOptions;
	deniedGridApi?: GridApi;
    orgStubs: OrganizationStub[];
    subscriptions: Subscription = new Subscription();
    pendingReviewDataCorrectionRequests: FlowIndex[];
    approvedDataCorrectionRequests: FlowIndex[];
    deniedDataCorrectionRequests: FlowIndex[];
    returnedDataCorrectionRequests: FlowIndex[];
    selectedItem: any;
    groupHasPermission: any;

    columnApplicationNumberColumn: ColDef = {
        headerClass: "wrapped",
        headerName: 'Application #',
        headerTooltip: 'Application #',
        tooltipField: 'flowIdentifier',
        field: 'flowIdentifier',
        cellRendererSelector: (params) => {
            if (params.data.onBehalf) {
                return {
                    component: ModalInfoComponent,
                    params: {
                        modalText: (data: any) => { return `Application ${data.flowIdentifier} is a paper submission that must be completed by ODNR.`; },
                        text: (data: any) => { return data.flowIdentifier; }
                    }
                }
            } else {
                return {
                    component: RouterLinkRendererComponent,
                    params: {
                        textField: 'flowIdentifier',
                        flowIdField: 'flowId',
                        workItemIdField: 'currentWorkItemId'
                    }
                }
            }
        },
        filter: "agTextColumnFilter",
        filterParams: this.gridFormatterService.defaultTextFilterParams,
        minWidth: 160,
        maxWidth: 175
    }

    columnDiscoveryApplicationNumberColumn: ColDef = {
        headerClass: "wrapped",
        headerName: "Application #",
        headerTooltip: "Application #",
        tooltipField: "flowIdentifier",
        field: "flowIdentifier",
        cellRenderer: ActionCellRendererComponent,
        cellRendererParams: {
            textField: 'flowIdentifier',
            action: this.getDiscoveryDocument(this)
        },
        filter: "agTextColumnFilter",
        filterParams: this.gridFormatterService.defaultTextFilterParams,
        minWidth: 160,
        maxWidth: 175
    }

    columnReturnedTabApplicationNumber: ColDef = {
        headerClass: "wrapped",
        cellRenderer: RouterLinkRendererComponent,
        cellRendererParams: {
            textField: 'flowIdentifier',
            openInNewWindow: false,
            url: (data: FlowIndex) => {
                const prefix = (data.onBehalf) ? "/flow/review-on-behalf" : "/flow/review";
                return `${prefix}/${data.flowId}`;
            }
        },
        headerName: 'Application #',
        headerTooltip: 'Application #',
        tooltipField: 'flowIdentifier',
        field: 'flowIdentifier',
        filter: "agTextColumnFilter",
        filterParams: this.gridFormatterService.defaultTextFilterParams,
        minWidth: 160,
        maxWidth: 175
    }

    columnCompanyName: ColDef = {
        headerName: 'Company Name',
        headerTooltip: 'Company Name',
        tooltipField: 'companyName',
        field: 'companyName',
        filter: "agTextColumnFilter",
        filterParams: this.gridFormatterService.defaultTextFilterParams,
        minWidth: 140,
        maxWidth: 150,
        headerClass: "wrapped"
    }

    columnCreatedDate: ColDef = {
        headerName: 'Created',
        headerTooltip: 'Created',
        field: 'createdDate',
        tooltipValueGetter: this.gridFormatterService.formatDate('createdDate'),
        valueGetter: this.gridFormatterService.formatDate('createdDate'),
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: this.gridFormatterService.defaultDateFilterParams,
        minWidth: 130,
        maxWidth: 140,
        headerClass: "wrapped"
    }

    columnObjectToChangeDataType: ColDef = {
        headerName: 'Type',
        headerTooltip: 'Type',
        field: 'dataType',
        minWidth: 135,
        maxWidth: 150,
        headerClass: "wrapped"
    }

    columnObjectToChangeId: ColDef = {
        headerName: 'Number',
        headerTooltip: 'Number',
        field: 'objectToCorrectId',
        filter: "agTextColumnFilter",
        filterParams: this.gridFormatterService.defaultTextFilterParams,
        minWidth: 135,
        maxWidth: 150,
        headerClass: "wrapped"
    }

    public columnDefs: ColDef[] = [
        this.columnCreatedDate,
        this.columnApplicationNumberColumn,
        this.columnCompanyName,
        this.columnObjectToChangeDataType,
        this.columnObjectToChangeId
    ];

    pendingAssignments: PendingWorkOrderAssignment[] = []; 

    public pendingReviewColumns: ColDef[] = [
        this.columnCreatedDate,
        this.columnApplicationNumberColumn,
        {
            headerClass: "wrapped",
            headerName: "Assignee",
            headerTooltip: "Assignee",
            tooltipField: "assignedUserId",
            field: "assignedUserId",
            suppressFiltersToolPanel: true,
            suppressMovable: true,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true,
            cellEditorParams: {
                formatValue: (value: any) => value?.displayName ?? 'Unassigned',
                values: this.filteredUsers
            },
            cellRenderer: this.renderAssignedUser,
            valueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedUserId) ?? null,
            filterValueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedUserId)?.displayName ?? 'Unassigned',
            valueSetter: this.assign,
            tooltipValueGetter: this.renderAssignedUser,
            onCellValueChanged: this.cellValueChanged,
            minWidth: 140,
            maxWidth: 150
        },
        this.columnCompanyName,
        this.columnObjectToChangeDataType,
        this.columnObjectToChangeId
    ];
    public approvedReviewColumns: ColDef[] = [this.columnCreatedDate, this.columnDiscoveryApplicationNumberColumn, this.columnCompanyName, this.columnObjectToChangeDataType, this.columnObjectToChangeId];
    public deniedReviewColumns: ColDef[] = [this.columnCreatedDate, this.columnDiscoveryApplicationNumberColumn, this.columnCompanyName, this.columnObjectToChangeDataType, this.columnObjectToChangeId];
    public returnedReviewColumns: ColDef[] = [this.columnCreatedDate, this.columnReturnedTabApplicationNumber, this.columnCompanyName, this.columnObjectToChangeDataType, this.columnObjectToChangeId];

    noDocumentsDialog: Dialog = new Dialog("No discovery document found for the given application.", [new DialogButton("OK", false, () => { return; })]);

    constructor(
        public workOrderService: WorkOrderService,
        public authService: AuthService,
        public datePipe: DatePipe,
        public dataCorrectionService: DataCorrectionService,
        public gridFormatterService: GridFormatterService,
        private flowInstanceService: FlowInstanceService,
        private router: Router,
        public dateService: DateService,
        private documentService: DocumentManagementService,
        private dialogService: DynamicDialogService,
        private loader: LoaderService,
        public groupService: GroupService 
    ) {
        super("ViewInternalDataCorrectionRequestsWidget", [LunaClaimValues.ViewInternalDataCorrectionRequestsWidget]);
        this.subscriptions.add(this.flowInstanceService.queryFlowIndices("PendingCorrectionRequestApplications")
            .subscribe((result: FlowIndex[]) => {
                this.pendingReviewDataCorrectionRequests = this.sortFlowIndices(result);
            }));

        this.subscriptions.add(this.flowInstanceService.queryFlowIndices("ApprovedCorrectionRequestApplications")
            .subscribe((result: FlowIndex[]) => {
                this.approvedDataCorrectionRequests = this.sortFlowIndices(result);
            }));

        this.subscriptions.add(this.flowInstanceService.queryFlowIndices("DeniedCorrectionRequestApplications")
            .subscribe((result: FlowIndex[]) => {
                this.deniedDataCorrectionRequests = this.sortFlowIndices(result);
            }));

        this.subscriptions.add(this.flowInstanceService.queryFlowIndices("ReturnedCorrectionRequestApplications")
            .subscribe((result: FlowIndex[]) => {
                this.returnedDataCorrectionRequests = this.sortFlowIndices(result);
            }));
    }

    ngOnInit() {
        this.refreshData(); 
        this.setGridOptions(); 
		this.approvedGridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.approvedReviewColumns); 
		this.approvedGridOptions.onGridReady = (params) => { this.approvedGridApi = params.api; };
		this.deniedGridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.deniedReviewColumns); 
		this.deniedGridOptions.onGridReady = (params) => { this.deniedGridApi = params.api; };
		this.returnedGridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.returnedReviewColumns); 
		this.returnedGridOptions.onGridReady = (params) => { this.returnedGridApi = params.api; };

        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    
    assign(params: any): any {
        let result: boolean = false; 
        if (params && params.newValue && params.newValue.id) {
            if (params.newValue.id != "-1") {
                params.data.assignedUserId = params.newValue.id;
            } else {
                params.data.assignedUserId = "";
            }

            if (params.context && params.context.componentParent) {
                let parent = <DataCorrectionRequestsInternalWidgetComponent>params.context.componentParent;
                let selectedItem = parent.allUsers.find(u => u.id == params.newValue.id);
                if (selectedItem) {
                    params.data.assignedUserName = selectedItem.displayName;
                }
            }
            result = true;
        }
        return result;
    }
    
    buildColumns(): ColDef[] {
        let colDefs: ColDef[] = [];
        colDefs.push(this.columnCreatedDate);
        colDefs.push(this.columnApplicationNumberColumn);
        colDefs.push({
            headerName: "Assignee",
            headerTooltip: "Assignee",
            field: "assignedUserId",
            suppressFiltersToolPanel: true,
            suppressMovable: true,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true,
            cellEditorParams: {
                formatValue: (value: any) => value?.displayName ?? 'Unassigned',
                values: this.filteredUsers
            },
            cellRenderer: this.renderAssignedUser,
            valueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedUserId) ?? null,
            filterValueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedUserId)?.displayName ?? 'Unassigned',
            valueSetter: this.assign,
            tooltipValueGetter: this.renderAssignedUser,
            onCellValueChanged: this.cellValueChanged,
            minWidth: 140
        } as ColDef);
        colDefs.push(this.columnCompanyName);
        colDefs.push(this.columnObjectToChangeDataType);
        this.gridFormatterService.applyFilterKeyboardHintTooltips(colDefs);
        return colDefs;
    }

    cellValueChanged(params): void {
        if (params.api) {
            params.api.refreshCells();
        }
    }

    onTabClicked(): void {
        this.pendingReviewGridApi.sizeColumnsToFit();
        this.approvedGridApi.sizeColumnsToFit();
        this.deniedGridApi.sizeColumnsToFit();
        this.returnedGridApi.sizeColumnsToFit();
    }
    
    getDataObs$(): Observable<[PendingFlow[], PendingFlow[], PendingFlow[], PendingFlow[]]> {
        this.showLoadingOverlays(true);

        let allUserSearchObs$ = this.groupService.get({ internal: true, stubs: false, fullContactDetails: true } as GroupSearchSpec);
        let pendingSearchObs$ = this.flowInstanceService.queryFlowIndices("PendingCorrectionRequestApplications").pipe(tap((data: PendingFlow[]) => {
            this.pendingReviewDataCorrectionRequests;
        }));
        let approvedSearchObs$ = this.flowInstanceService.queryFlowIndices("ApprovedCorrectionRequestApplications").pipe(tap((data: PendingFlow[]) => {
            this.approvedDataCorrectionRequests;
        }));
        let deniedSearchObs$ = this.flowInstanceService.queryFlowIndices("DeniedCorrectionRequestApplications").pipe(tap((data: PendingFlow[]) => {
                this.deniedDataCorrectionRequests;
        }));
        let returnedSearchObs$ = this.flowInstanceService.queryFlowIndices("ReturnedCorrectionRequestApplications").pipe(tap((data: PendingFlow[]) => {
                this.returnedDataCorrectionRequests;
        }));
        let level1Subs$ = allUserSearchObs$.pipe(mergeMap((groupData) => {
            this.allUsers = [];
            this.filteredUsers = [];
            if (groupData) {
                if (groupData instanceof Array) {
                    this.groups = groupData as Group[];
                    this.groups.forEach(g => this.allUsers = this.allUsers.concat(g.users));
                }
                this.allUsers = this.filterUniqueUsers(this.allUsers);
                this.allUsers.unshift({ id: "-1", displayName: "Unassigned" } as ContactStub);
            }
            return forkJoin(pendingSearchObs$, approvedSearchObs$, deniedSearchObs$, returnedSearchObs$);
        }));
        return level1Subs$;

    }
    
    buildUserList(groups: Group[]): ContactStub[] {
        let userList: ContactStub[] = [];
        groups.forEach(u => userList = userList.concat(u.users));
        userList = this.filterUniqueUsers(userList);
        userList = this.sortUsers(userList);
        userList.unshift({ id: "-1", displayName: "Unassigned" } as ContactStub);
        return userList;
    }
    
    filterUniqueUsers(users: ContactStub[]): ContactStub[] {
        return users.filter((user, i, arr) => arr.findIndex(t => t.id === user.id) === i);
    }
    
    refreshData(): void {
        let subs$ = this.getDataObs$().pipe(
            map(([level1Rows]) => {
                let level1Groups = this.groups.filter(g => this.groupHasPermission(g) && this.groupService.get({internal: true}) != null);
                this.filteredUsers = this.buildUserList(level1Groups);
            })
        ).subscribe(() => {
            this.pendingReviewGridApi.setGridOption("columnDefs", []);
            this.pendingReviewGridApi.setGridOption("columnDefs", this.buildColumns());
        }, (error) => {
            console.error(error);
        });
        this.subscriptions.add(subs$);
    }
    
    renderUserDropdownOptions(params: any): string {
        let returnValue = params && params.value && params.value.displayName ? params.value.displayName : "Unassigned";
        return returnValue;
    }
    
    renderAssignedUser(params: any): string {
        let returnValue: string = "Unassigned";
        if (params && params.data && params.data.assignedUserId && params.data.assignedUserName) {
            returnValue = params.data.assignedUserName;
        }
        return returnValue;
    }
    
    saveAssignments(event: any): void {
        let changedItem = <PendingFlow>event.data;
        if (event.context && event.context.componentParent) {
            const component = <DataCorrectionRequestsInternalWidgetComponent>event.context.componentParent;
            const pending = new PendingWorkOrderAssignment(changedItem?.currentWorkItemId ?? "", changedItem.assignedUserId, changedItem.assignedUserName, true, changedItem.flowId);
            let updateSubs$ = component.workOrderService.assignWorkOrder(pending).pipe()
                .subscribe({
                    next: (result) => { console.log("update managed"); },
                    error: (error) => { console.error(error); }
                });
            component.subscriptions.add(updateSubs$);
        }
    }
    
    setGridOptions(): void {
        this.pendingReviewGridOptions = <GridOptions>{
            columnDefs: this.buildColumns(),
            context: {
                componentParent: this
            },
            defaultColDef: { filter: true, resizable: true, sortable: true, editable: true, headerClass: "wrapped" } as ColDef,
            enableBrowserTooltips: false,
            tooltipTrigger: 'focus',
            onCellValueChanged: ($event) => this.saveAssignments($event),
            pagination: true,
            paginationAutoPageSize: true,
			suppressHorizontalScroll: false,
			onGridReady: (params) => { this.pendingReviewGridApi = params.api; },
            headerHeight: 50
        };
    }
    
    showLoadingOverlays(show: boolean): void {
        if (this.pendingReviewGridApi) {
            if (show) {
                this.pendingReviewGridApi.setGridOption("rowData", []);
                this.pendingReviewGridApi.setGridOption("loading", true);
            } else
                this.pendingReviewGridApi.setGridOption("loading", false);
        }
    }
    
    sortUsers(users: ContactStub[]): ContactStub[] {
        return users.sort((a, b) => {
            if (a.lastName > b.lastName) return 1;
            if (a.lastName < b.lastName) return -1;
            if (a.lastName == b.lastName) {
                if (a.firstName > b.firstName) return 1;
                if (a.firstName < b.firstName) return -1;
            }
            return 0;
        })
    }

    getDiscoveryDocument(evt: any) {
        return (obj: any) => {           
            this.loader.toggleLoader(true);
            const model: OnBaseQueryModel = {
                documentTypeIds: [],
                documentTypeNames: ["DNR - OG - LADM-e-Discovery - Request Document"],
                maxResults: 500,
                resultsPerPage: 50,
                pageNumber: 1,
                displayKeywordTypes: [],
                searchParameters: [],
                sort: SortAttribute.DocumentDate,
                isAscending: false
            } as OnBaseQueryModel;
            const spec = new OnBaseDocumentTypeSearchSpec();
            spec.documentGroupName = "DNR - OG - LADM-e-Discovery - Request Document";
            const doc$ = this.documentService.getKeywordTypesByDocumentTypeName(model.documentTypeNames[0]).pipe(
                mergeMap((keywords: OnBaseKeyword[]) => {
                    const applicationWords = keywords.filter(k => k.name.toLocaleLowerCase().includes("dogrm - application id number"));
                    if (applicationWords.length > 0) {
                        const keywordQuery = new OnBaseKeywordQuery(applicationWords[0].id, applicationWords[0].name, obj.value, "eq");
                        model.searchParameters.push(keywordQuery);
                        return this.documentService.query(model);
                    } 
                    return of(null);
                }),
                mergeMap((result: QueryResult | null) => {
                    if (result == null || result.totalRecords === 0) return of(null);
                    return this.documentService.download(result.records[0].documentId);
                })
            ).subscribe({                
                next: (docData: HttpResponse<Blob> | null) => {
                    this.loader.toggleLoader(false);
                    if (docData == null) {
                        this.showNoDocuments();
                    } else {
                        const fileName = parseFileNameFromHeaders(docData.headers.get("content-disposition"));
                        const blob = new Blob([docData.body], { type: docData.body.type });
						const blobUrl = window.URL.createObjectURL(blob);
						const anchor = <HTMLAnchorElement>this.documentLink.nativeElement;
						anchor.href = blobUrl;
						anchor.download = fileName;
						anchor.click();
                    }
                },
                error: (error) => {
                    console.error(error);
                    this.loader.toggleLoader(false);
                }
            });
            this.subscriptions.add(doc$);
        }
        
    }

    get user(): UserIdentity {
        return this.authService.User;
    }

    showNoDocuments(): void {
        this.noDocumentsDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.noDocumentsDialog);
    }

    sortFlowIndices(indices: FlowIndex[]): FlowIndex[] { //sort by date submitted if available, then by created date if not
        return indices.sort((a, b) => {
            if (a.dateSubmitted < b.dateSubmitted) return -1;
            if (a.dateSubmitted > b.dateSubmitted) return 1;
            if (a.createdDate < b.createdDate) return -1;
            if (a.createdDate > b.createdDate) return 1;
            return 0;
        });
    }
}
